// extracted by mini-css-extract-plugin
export default {"title":"styles_title__mpeA4","subTitle":"styles_subTitle__MYTKG","width100":"styles_width100__vX0s0","connectWrapper":"styles_connectWrapper__IJ8Je"};